<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="400px">
      <template v-slot:activator="{ on }">
        <v-btn flat block small class="mt-2 caption" v-on="on"
          ><v-icon size="16">add</v-icon> Nova Pasta</v-btn
        >
      </template>
      <v-card style="background: white !important">
        <v-card-title>
          <span class="headline">{{ formLabel }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>
                <v-text-field
                  v-model="model.name"
                  label="Nome da Pasta"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" flat @click="onSubmit">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    formType: String,
    category: Object,
  },
  data() {
    return {
      model: {
        name: "",
      },
      dialog: false,
    };
  },
  methods: {
    onSubmit() {
      const type = this.formType;
      const payload = { ...this.model };
      this.$emit(type, payload);
      this.dialog = false;
      this.model.name = "";
    },
  },
  computed: {
    formLabel() {
      const labels = {
        create: "Criar nova Pasta",
        update: "Editar Pasta",
      };
      return labels[this.formType];
    },
  },
  watch: {
    category: function (v) {
      this.$nextTick(() => {
        this.dialog = v ? true : false;
        this.model.name = v ? v.name : "";
      });
    },
  },
};
</script>

<style lang="scss" scope>
</style>
